<template>
  <div @click="$emit('click')" class="click-wrapper" :class="{ disabled: disabled }">
    <CustomTooltip title="Más Información" placement="bottom" :disabled="!description">
      <template #content>
        <ul class="text-left text-gray-600 list-disc pl-5">
          <li><strong>Marca:</strong> {{ effect.marca || "—" }}</li>
          <li><strong>Categoría:</strong> {{ effect.categoria || "—" }}</li>
          <li><strong>Sub-Categoría:</strong> {{ effect.subCategoria || "—" }}</li>
          <li><strong>Modelo:</strong> {{ effect.modelo || "—" }}</li>
          <li><strong>Tipo:</strong> {{ effect.tipo || "—" }}</li>
          <li><strong>Estado:</strong> {{ effect.estado || "—" }}</li>
        </ul>
      </template>
      <Card
        class="customCard primaryFont"
        :class="{ 'disabled-card': disabled }"
        :style="{
          borderLeft: `6px solid ${borderColor}`,
          backgroundColor: `${isSelected ? '#EEEEEE' : '#FFFFFF'}`,
        }"
      >
        <template #title>
          <div class="flex w-full justify-content-between">
            <span class="cardTitle" :class="{ 'disabled-text': disabled }">{{ effect.marca }}</span>
            <StateChip :stateColor="getStatusColors(effect.estado)" :stateText="effect.estado" />
          </div>
        </template>
        <template #content>
          <span class="cardText" :class="{ 'disabled-text': disabled }">{{ description }}</span>
        </template>
      </Card>
    </CustomTooltip>
  </div>
</template>

<script setup>
import StateChip from "@/pages/sumario/componentsViewActuacion/StateChip.vue";
import { computed, ref } from "vue";

const props = defineProps({
  effect: Object,
  isSelected: Boolean,
  isPreview: { type: Boolean, default: false },
  disabled: { type: Boolean, default: false },
});

const description = computed(() => {
  const { categoria, subCategoria } = props.effect;
  return `${categoria} - ${subCategoria}`;
});

const getStatusColors = (status) => {
  const colors = {
    denunciado: { fontColor: "#D20F39", backgroundColor: "#FFD2CA" },
    secuestrado: { fontColor: "#D97706", backgroundColor: "#FFFBEB" },
    recuperado: { fontColor: "#1A8245", backgroundColor: "#DAF8E6" },
  };

  return colors[status.toLowerCase()] || { fontColor: "#949494", backgroundColor: "#DFDFDF" };
};

const borderColor = computed(() => {
  if (props.isPreview) return "#0B5195";

  const colors = {
    denunciado: "#D20F39",
    secuestrado: "#D97706",
    recuperado: "#1A8245",
  };
  return colors[props.effect.estado?.toLowerCase()] || "#000000";
});
</script>
<style scoped>
.customCard {
  border-radius: 8px;
  box-shadow: 0px 4px 4px 0px #00000040;
  max-height: 104px;
  display: flex;
  justify-content: start;
  align-items: center;
}

.disabled-card {
  opacity: 0.6;
  background-color: #f5f5f5 !important;
  cursor: not-allowed;
}

.disabled-text {
  color: #999999 !important;
}

.disabled {
  cursor: not-allowed;
  pointer-events: none;
}

.cardTitle {
  font-weight: 700;
  font-style: bold;
  font-size: 24px;
  color: black;
}

.cardText {
  font-weight: 700;
  font-style: bold;
  font-size: 16px;
  color: black;
}

>>> .p-card .p-card-body {
  width: 100% !important;
}

.click-wrapper {
  cursor: pointer;
  max-height: 104px;
}

.preview-mode {
  cursor: default;
}
</style>
